<template>
    <div class="vc-panel" v-loading="showLoading">
        <BookDetailsHeader :bookInfo="bookInfo"></BookDetailsHeader>
        <div class="vh-full v-flex mcontainer" v-if="bookInfo!=null">
            <BookDetailsLeftPanel  @eventHandle="leftPanelEvent" :bookInfo="bookInfo" :selectUnit="currentUnit" :listUnit="listUnit"></BookDetailsLeftPanel>
            <BookDetailsRightPanel :bookInfo="bookInfo" :selectUnit="currentUnit"></BookDetailsRightPanel>
        </div>
    </div>
</template>

<script>
import BookDetailsHeader from './views/BookDetailsHeader.vue';
import BookDetailsLeftPanel from './views/BookDetailsLeftPanel.vue';
import BookDetailsRightPanel from './views/BookDetailsRightPanel.vue';

import httpClient from '@/commom/http/httpClient';
export default {
    name: 'BookDetailsPage',
    components: {
        BookDetailsHeader,
        BookDetailsLeftPanel,
        BookDetailsRightPanel
    },
    data(){
        return {
            showLoading:false,
            bookId:"",
            bookInfo:null,
            listUnit:[],
            currentUnit:null
        }
    },
    mounted:function(){
        this.bookId = this.$route.params.bookId
        this.loadBookDetails()
        this.loadListUnit()
    },
    methods:{
        ///加载课程详情
        loadBookDetails:function(){
            this.showLoading = true
            var that = this
            var req = {
                bookId:this.bookId
            }
            httpClient.invoke("UserBookAPI.GetBookDetalis",req,function(res){
                that.showLoading = false
                //console.log("返回结果",res)
                if(res.error){
                    that.$message({message:res.error})
                    return
                }
                that.bookInfo = res
            })
        },
        ///加载单元列表
        loadListUnit:function(callback){
            var that = this
            var req = {
                bookId:this.bookId
            }
            httpClient.invoke("BookUnitAPI.GetList",req,function(res){
                console.log("返回结果1",res)
                if(res.error){
                    that.$message({message:res.error})
                    return
                }
                that.listUnit = res.listItem
                if(that.currentUnit == null && that.listUnit.length>0){
                    that.selectUnit(that.listUnit[res.selectIndex])
                }
                if(callback){
                    callback()
                }
            })
        },
        selectUnit:function(unit){
            this.currentUnit = unit
        },
        ///左面板事件
        leftPanelEvent:function(req){
            var that = this
            switch(req.name){
                case "newUnitReload":
                    this.loadListUnit(function(){
                        if(that.listUnit.length>0){
                            that.selectUnit(that.listUnit[that.listUnit.length-1])
                        }
                    })
                    break;
                case "selectUnit":
                    this.selectUnit(req.data)
                    break;
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media only screen and (min-width: 1601px) {
  /* 当屏幕宽度大于1600px时应用的样式 */
  .mcontainer{
    max-width: 1400px;
    min-width: 1400px;
    margin: 0 auto;
  }
}
</style>
